import {loadIfNeeded} from '../gdpr';

type CMPSdkApi = (command: string, parameter?: string, callback?: (value: boolean, success: boolean) => void) => void;

interface GDPRWindow extends Window {
  __cmp?: CMPSdkApi;
  __uspapi?: CMPSdkApi;
}

const openSettings = () => {
  const win = window as GDPRWindow;
  const cmpApi = win.__uspapi || win.__cmp;

  if (cmpApi) {
    cmpApi('openSettings');
  }
};

export const initSettingsLinks = async () => {
  const hasLoaded = await loadIfNeeded({render: false});

  if (!hasLoaded) {
    return;
  }

  const links: HTMLElement[] = Array.from(document.querySelectorAll('[data-gdpr-settings-link]'));

  for (const link of links) {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      openSettings();
    });
  }
};
